export default "__VITE_ASSET__b0f5ba02__"